import React from "react";
import { Box } from "@mui/material";
import {
  FooterLegalContainer,
  FooterStyled,
  FooterWrapper,
  FooterPrivacyContainerNew,
  FooterAccreditationRow,
  PatentContent,
  FooterLink,
  FooterPrivacyContainerTelephone,
  FooterPrivacyContainerTelephoneRow,
} from "./Footer.styles";
import { FooterAccreditationInfoTop } from "./FooterAccreditationInfoTop";
import { FooterAcreditationInfoBottom } from "./FooterAccreditationInfoBottom";
import { GetTypographyContent } from "../shared/Typography/Typography";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { RELEASE_NOTES_URL } from "../../utils/urlConstants";

export const Footer = (): React.ReactElement => {
  const { isDesktop, deviceType } = useDeviceHook();

  return (
    <>
      <FooterStyled deviceType={deviceType}>
        <FooterWrapper data-testid="footerTestId" isDesktop={isDesktop}>
          <FooterLegalContainer isDesktop={isDesktop}>
            <Box width="100%" display="block" whiteSpace="pre-line">
              {GetTypographyContent({
                content: `1035 O’Brien Drive, Menlo Park, CA 94025 © 2016 – ${new Date().getFullYear()} • BillionToOne Inc. • All rights reserved.`,
                size: "small",
              })}

              <PatentContent isDesktop={isDesktop}>
                {GetTypographyContent({
                  content:
                    "BillionToOne® Registered in U.S. Patent and Trademark Office.",
                  size: "small",
                })}
              </PatentContent>
              <Box
                width="fit-content"
                display="flex"
                whiteSpace={isDesktop ? "pre" : "pre-wrap"}
                flexWrap="wrap"
              >
                &nbsp;
                <FooterLink>
                  {GetTypographyContent({
                    content: "Privacy Policy ",
                    size: "small",
                    link: "https://www.billiontoone.com/privacy-policy",
                    textColor: "greenDark",
                    externalLink: true,
                    textDecoration: "underline",
                  })}
                </FooterLink>
                {GetTypographyContent({
                  content: " • ",
                  size: "small",
                })}
                <FooterLink>
                  {GetTypographyContent({
                    content: "Notice of Privacy Practices",
                    size: "small",
                    textColor: "greenDark",
                    link: "https://www.billiontoone.com/privacy-practices",
                    externalLink: true,
                    textDecoration: "underline",
                  })}
                </FooterLink>
                {GetTypographyContent({
                  content: " • ",
                  size: "small",
                })}
                <FooterLink>
                  {GetTypographyContent({
                    content: "Accessibility Statement",
                    size: "small",
                    textColor: "greenDark",
                    link: "https://www.billiontoone.com/accessibility-statement",
                    externalLink: true,
                    textDecoration: "underline",
                  })}
                </FooterLink>
                {GetTypographyContent({
                  content: " • ",
                  size: "small",
                })}
                <FooterLink>
                  {GetTypographyContent({
                    content: "Terms of Use",
                    size: "small",
                    textColor: "greenDark",
                    link: "https://www.billiontoone.com/terms-of-use",
                    externalLink: true,
                    textDecoration: "underline",
                  })}
                </FooterLink>
                {GetTypographyContent({
                  content: " • ",
                  size: "small",
                })}
                <FooterLink>
                  {GetTypographyContent({
                    content: "Release Notes",
                    size: "small",
                    textColor: "greenDark",
                    link: RELEASE_NOTES_URL,
                    textDecoration: "underline",
                  })}
                </FooterLink>
              </Box>
            </Box>
          </FooterLegalContainer>
          <FooterPrivacyContainerTelephone>
            <FooterPrivacyContainerTelephoneRow>
              {GetTypographyContent({
                content: "T ",
                size: "small",
              })}
              {GetTypographyContent({
                content: "+1 (650) 460-2551",
                size: "small",
              })}
            </FooterPrivacyContainerTelephoneRow>
            <FooterPrivacyContainerTelephoneRow>
              {GetTypographyContent({
                content: "E ",
                size: "small",
              })}
              {GetTypographyContent({
                content: "support@unityscreen.com",
                size: "small",
              })}
            </FooterPrivacyContainerTelephoneRow>
            <FooterPrivacyContainerTelephoneRow>
              {GetTypographyContent({
                content: "F ",
                size: "small",
              })}
              {GetTypographyContent({
                content: "+1 (833) 915-0146",
                size: "small",
              })}
            </FooterPrivacyContainerTelephoneRow>
          </FooterPrivacyContainerTelephone>

          <FooterPrivacyContainerNew>
            <FooterAccreditationRow>
              <FooterAccreditationInfoTop />
            </FooterAccreditationRow>
            <FooterAccreditationRow>
              <FooterAcreditationInfoBottom />
            </FooterAccreditationRow>
          </FooterPrivacyContainerNew>
        </FooterWrapper>
      </FooterStyled>
    </>
  );
};
